<ul nz-menu nzMode="vertical">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>
  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus">
      <li *ngIf="!menu.children" nz-menu-item [nzMatchRouter]="true"
        class="navigation-item color-natural-5" [ngClass]="{ collapsedItem: isCollapsed }" nz-tooltip
        [nzTooltipTrigger]="isCollapsed ? 'hover' : undefined" [nzTooltipTitle]="menu.title">
        <a [routerLink]="menu.routerLink">
          <span nz-icon *ngIf="menu.icon">
            <i [class]="'fa-light fa-' + menu.icon"></i>
          </span>
          <span nz-icon *ngIf="!menu.icon" nzType="file" nzTheme="outline">
          </span>
          <span *ngIf="!isCollapsed">{{ menu.title  | translate  }}</span>
        </a>
      </li>
      <ng-container *ngIf="menu.children">
        <nz-divider></nz-divider>
        <li nz-menu-item *ngFor="let item of menu.children"
          [ngClass]="{ collapsedItem: isCollapsed }" nz-tooltip
          [nzTooltipTrigger]="isCollapsed ? 'hover' : undefined" [nzTooltipTitle]="item.title">
          <a [routerLink]="item.routerLink" class="navigation-item color-natural-5" [routerLinkActive]="['active']">
            <ng-container nz-icon *ngIf="item.icon">
              <i [class]="'fa-light fa-' + item.icon"></i>
            </ng-container>
            <ng-container nz-icon *ngIf="item.icon == null" nzType="file" nzTheme="outline"></ng-container>
            <ng-container *ngIf="!isCollapsed">
              {{ item.title  | translate }}
            </ng-container>
          </a>
        </li>
      </ng-container>
    </ng-container>
  </ng-template>
</ul>
<ul nz-menu nzMode="vertical" class="more-menu">
  <li nz-submenu nzTitle="More">
    <ul>
      <li nz-menu-item>
        <a [routerLink]="['/settings/tag/index']" [routerLinkActive]="['active']">
         {{'Product Tags' | translate}}
        </a>
      </li>
      <li nz-menu-item>
        <a [routerLink]="['/settings/product-status/index']" [routerLinkActive]="['active']">
         {{'Product Statuses' | translate}}
        </a>
      </li>
      <li nz-menu-item>
        <a [routerLink]="['/settings/relationship/index']" [routerLinkActive]="['active']">
          {{'Relationships' | translate}}
        </a>
      </li>
      <li nz-menu-item>
        <a [routerLink]="['/completion/list']" [routerLinkActive]="['active']">
          {{'Completion Sets' | translate}}
        </a>
      </li>
      <li nz-menu-item>
        <a [routerLink]="['/settings/display-properties/index']" [routerLinkActive]="['active']">
          {{'Display Properties' | translate}}
        </a>
      </li>
      <li nz-menu-item>
        <a [routerLink]="['/settings/language/index']" [routerLinkActive]="['active']">
          {{'Languages' | translate}}
        </a>
      </li>
      <li nz-menu-item >
        <a [routerLink]="['/data-import/importation-templates-list']" [routerLinkActive]="['active']">
          {{'Importation Templates' | translate}}
        </a>
      </li>
      <!-- <li nz-menu-item >
        <a [routerLink]="['/product-catalog/catalog-list']">
          Catalogs
        </a>
      </li> -->
    </ul>
  </li>
</ul>
